export default "__VITE_ASSET__Mu$nFBq4__"